import requests from "./httpService";

const UserServices = {

    getsingleData : async (id) =>{
   
        return requests.get(`/profile/user/${id}`);
    },
    getAllUserSearch : async () =>{
   
        return requests.get(`/profile/pro`);
    },
    getAllUser: async (page, search, status, verified, district, policeStation, date) => {
        let queryParams = `page=${page}`;
        if (search) queryParams += `&search=${encodeURIComponent(search)}`;
        if (status) queryParams += `&status=${encodeURIComponent(status)}`;
        if (verified) queryParams += `&verified=${encodeURIComponent(verified)}`;
        if (district) queryParams += `&district=${encodeURIComponent(district)}`;
        if (policeStation) queryParams += `&policeStation=${encodeURIComponent(policeStation)}`;
        if (date) queryParams += `&date=${encodeURIComponent(date)}`;
        return requests.get(`/profile?${queryParams}`);
    },
    getAllReport: async () => {
        return requests.get(`/profile/download-excel`);
    },
    downloadProfile: (search, status, verified, district, policeStation, date) => {
        const params = new URLSearchParams();
        if (search) params.append('search', search);
        if (status) params.append('status', status);
        if (verified) params.append('verified', verified);
        if (district) params.append('district', district);
        if (policeStation) params.append('policeStation', policeStation);
        if (date) params.append('date', date);
        const qs = params.toString();
        return `${process.env.REACT_APP_API_BASE_URL}/profile/download-profile${qs ? '?' + qs : ''}`;
    },
    getcircleThanaProfiles: async (page, status, verified, district, policeStation, date, limit) => {
        let queryParams = `page=${page || 1}`;
        if (limit) queryParams += `&limit=${limit}`;
        if (status) queryParams += `&status=${encodeURIComponent(status)}`;
        if (verified) queryParams += `&verified=${encodeURIComponent(verified)}`;
        if (district) queryParams += `&district=${encodeURIComponent(district)}`;
        if (policeStation) queryParams += `&policeStation=${encodeURIComponent(policeStation)}`;
        if (date) queryParams += `&date=${encodeURIComponent(date)}`;
        return requests.get(`/admin/thanaName?${queryParams}`);
    },
    getDistrictOfficerProfiles: async (page, status, verified, district, policeStation, date, limit) => {
        let queryParams = `page=${page || 1}`;
        if (limit) queryParams += `&limit=${limit}`;
        if (status) queryParams += `&status=${encodeURIComponent(status)}`;
        if (verified) queryParams += `&verified=${encodeURIComponent(verified)}`;
        if (district) queryParams += `&district=${encodeURIComponent(district)}`;
        if (policeStation) queryParams += `&policeStation=${encodeURIComponent(policeStation)}`;
        if (date) queryParams += `&date=${encodeURIComponent(date)}`;
        return requests.get(`/admin/districtOfficerProfiles?${queryParams}`);
    },
    updateUser : async (id,body) =>{
        return requests.patch(`/profile/${id}`,body);
    },
    updateUserStatus : async (id,body) =>{
        return requests.patch(`/profile/${id}/status`,body);
    },
    getMyProfile : async () =>{
        return requests.get(`/userapp/profile`);
    },
    updateMe : async (body) =>{
        return requests.patch(`/userapp/updateMe`,body);
    },
    createAdmin : async (body) =>{
        // console.log(body)
        return requests.post(`/userapp/`,body);
    },
    updatePassword : async (body) =>{
        return requests.patch(`/userapp/change-password`,body);
    },
    dashboard : async () =>{
        return requests.get(`/userapp/dashboard`);
    },
    getAllAdmin : async () =>{
        return requests.get(`/userapp`);
    },
    getAllThanaAdmin : async () =>{
        return requests.get(`/userapp/get`);
    },
    getState : async () =>{
        return requests.get(`/state`);
    },
    getDistrictByState: async (id,body) =>{
        return requests.get(`/state/${id}`,body);
    },
    getThanaByDistrict: async (id,body) =>{
        return requests.get(`/state/districts/${id}`,body);
    },
    getCircleByDistrict: async (id,body) =>{
        return requests.get(`/state/circle-names/${id}`,body);
    },
    updateAdmin: async (id,body) =>{
        return requests.patch(`/userapp/${id}`,body);
    },
    deleteAdmin: async (id,body) =>{
        return requests.delete(`/userapp/${id}`,body);
    },
    login: async (body) =>{
        return requests.post(`/userapp/login`,body);
    },
    verifyElectricBill: async (body) => {
        return requests.post(`/profile/electricbill`, body);
    },
    verifyWaterBill: async (body) => {
        return requests.post(`/profile/waterbill`, body);
    },
    getOccupations: async () => {
        return requests.get(`/govt/occupation`);
    },
   
    

   


}

export default UserServices;


